import { render, staticRenderFns } from "./user-bio-3.vue?vue&type=template&id=2d538fd9&scoped=true"
import script from "./user-bio-3.vue?vue&type=script&lang=js"
export * from "./user-bio-3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d538fd9",
  null
  
)

export default component.exports